import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../services/axiosInstance";

export const varifyCaptcha = createAsyncThunk(
  "login/varifyCaptcha",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.post("/verify-captcha", payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something went wrong",
      );
    }
  },
);

export const loginUser = createAsyncThunk(
  "login/loginUser",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.post("/login", payload);
      // console.log("The res is :", res.data);
      if (!res.data.status) {
        return rejectWithValue(res.data.message);
      }

      return res.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something went wrong",
      );
    }
  },
);

export const forgotPassword = createAsyncThunk(
  "login/forgotPassword",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.post("/forget-password", payload);
      // console.log("The res of forgot password is :", res.data);

      if (!res.data.success) {
        return rejectWithValue(res.data.message);
      }
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something went wrong",
      );
    }
  },
);

// If admin logs in using admin panel then admin will go back again on admin panel

export const goBackToPenal = createAsyncThunk(
  "login/goBackToPenal",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.post("/return-to-admin", payload);

      // ✅ Backend success check (IMPORTANT)
      if (!res.data?.status && !res.data?.success) {
        return rejectWithValue(
          res.data?.message || "Failed to return to admin",
        );
      }

      // ✅ Proper return
      return res.data;
    } catch (err) {
      console.error("Return to admin error:", err);

      return rejectWithValue(
        err?.response?.data?.message || err?.message || "Something went wrong",
      );
    }
  },
);

// used verify-otp and set-password api from register thunk by just changing the type of otp from register_otp to login_otp
